// extracted by mini-css-extract-plugin
export default {"InfoMessage":"ModalBody_InfoMessage__k1iou","Label":"ModalBody_Label__wFmfC","MarginTop":"ModalBody_MarginTop__KmhX3","SearchIcon":"ModalBody_SearchIcon__BIczb"};